import { booleanAttribute, Component, effect, inject, InjectionToken, input } from '@angular/core';
import { PageLoadingService } from './page-loading.service';

export type SpinnerVariant = 'default' | 'redesign';

// lets an app switch every app-spinner to another variant, e.g. public-web-app provides 'redesign'
export const SPINNER_DEFAULT_VARIANT = new InjectionToken<SpinnerVariant>('SPINNER_DEFAULT_VARIANT', {
  factory: () => 'default'
});

@Component({
    selector: 'app-spinner',
    templateUrl: './spinner.component.html',
    styleUrls: ['./spinner.component.scss'],
    standalone: false
})
export class SpinnerComponent {
  isLoading = input(false, { transform: booleanAttribute });
  isFixedPosition = input(true, { transform: booleanAttribute });
  isWithSearchPanel = input(false, { transform: booleanAttribute });
  // false keeps a fixed spinner from marking the page as loading, so the layout keeps showing the footer
  isPageLoader = input(true, { transform: booleanAttribute });
  // 'redesign' renders the same icon spinner as the front page infinite scroll
  variant = input<SpinnerVariant>(inject(SPINNER_DEFAULT_VARIANT));

  private pageLoading = inject(PageLoadingService);

  constructor() {
    // a fixed spinner covers the whole page, so it marks the page as loading until it stops or is destroyed
    effect(onCleanup => {
      if (this.isLoading() && this.isFixedPosition() && this.isPageLoader()) {
        this.pageLoading.start();
        onCleanup(() => this.pageLoading.stop());
      }
    });
  }
}
